import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {DocumentManagerOptions} from "../Manager/PDFManager/DocumentManager.Options";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {SelectAPDF} from "../Controls/SelectAPDF";
import {ToastService} from "shared/core/services/ToastService";

export class WelcomeDialog extends DynamicDialog<WelcomeDialogProps, WelcomeDialogState> {
    static defaultProps: Partial<WelcomeDialogProps> = {};

    constructor(props: WelcomeDialogProps) {
        super(props);
        this.state = {
            IsOpen: true,
            IsBusy: false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:"New template",
            EnableCancel:false,
            EnableApply:true,
            OnClose:()=> {
                if(this.props.DocumentManager.Document==null||this.props.DocumentManager.Options.FormId=='')
                {
                    window.location.href=rnImporterVar.DesignerURL;
                }

            },
            ApplyTitle:'Done',
            OnApply:()=>{
                if(this.props.DocumentManager.Options.FormId=='') {
                    ToastService.SendErrorMessage('Form is mandatory');
                    return false;
                }

                if(this.props.DocumentManager.Document==null)
                {
                    ToastService.SendErrorMessage('PDF file is mandatory');
                    return false;
                }
                this.SendResult(true);
            }
        };
    }

    SubRenderer(): ReactNode {
        return (
            <div>
                <h3 style={{margin:0}}>Before starting please select a form and import a pdf.</h3>

                <div style={{marginTop:15}}>
                    <SearchableSelect<DocumentManagerOptions> className={'cbSelectForm'} Label={'Selected form'} Value={this.props.DocumentManager.Options.FormId} onChange={e=>{this.props.DocumentManager.SetFormId(e);this.forceUpdate()}}>
                        {rnImporterVar.FormList.map(form=>
                            <option value={form.Id} key={form.Id}>{form.Name}</option>
                        )}
                    </SearchableSelect>
                    <SelectAPDF Manager={this.props.DocumentManager}/>
                </div>
            </div>
        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WelcomeDialogProps extends DynamicDialogProps {
    DocumentManager:DocumentManager;
}

interface WelcomeDialogState extends DynamicDialogState {

}

//#endregion "My Region"